<template>
    <div class="shop-orders-tab">
        <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
            <div>
                <h5 class="mb-1">Manajemen Order</h5>
                <small class="text-muted">Kelola pesanan, pembayaran, dan pengiriman</small>
            </div>
            <div class="d-flex flex-wrap gap-2">
                <button class="btn btn-outline-success btn-sm" @click="exportCSV" :disabled="exporting">
                    <i class="fas fa-download"></i> Export CSV
                </button>
                <button class="btn btn-light btn-sm" @click="refreshTable" :disabled="loading">
                    <i class="fas fa-sync" :class="{ 'fa-spin': loading }"></i> Refresh
                </button>
            </div>
        </div>

        <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
            <OrderTable
                ref="orderTable"
                :shop-id="shopId"
                @view-detail="viewOrderDetail"
                @loading="loading = $event"
            />
        </div>

        <modal name="order_detail" :height="'auto'" :adaptive="true" :scrollable="true" width="720">
            <div style="margin: 0">
                <OrderDetailModal
                    v-if="selectedOrderId"
                    :order-id="selectedOrderId"
                    :shop-id="shopId"
                    @close="closeModal"
                    @updated="refreshTable"
                />
            </div>
        </modal>
    </div>
</template>

<script>
import OrderTable from '@/components/tables/ShopOrder.vue';
import OrderDetailModal from '@/components/modals/shop/OrderDetailModal.vue';
import axios from 'axios';

export default {
    name: 'ShopOrdersTab',
    components: { OrderTable, OrderDetailModal },
    props: {
        shopId: { type: Number, required: true },
    },
    data() {
        return {
            selectedOrderId: null,
            loading: false,
            exporting: false,
        };
    },
    methods: {
        viewOrderDetail(orderId) {
            this.selectedOrderId = orderId;
            this.$modal.show('order_detail');
        },
        closeModal() {
            this.$modal.hide('order_detail');
            this.selectedOrderId = null;
        },
        refreshTable() {
            if (this.$refs.orderTable) this.$refs.orderTable.loadOrders();
        },
        async exportCSV() {
            this.exporting = true;
            try {
                const r = await axios.get(`shops/${this.shopId}/report`, {
                    params: { type: 'orders', export: 'csv' },
                    responseType: 'blob',
                });
                const url = window.URL.createObjectURL(new Blob([r.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = `orders-shop-${this.shopId}.csv`;
                a.click();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                this.$toast?.error?.('Gagal export: ' + (e.response?.data?.message || e.message));
            } finally {
                this.exporting = false;
            }
        },
    },
};
</script>

<style scoped>
.gap-2 > * + * { margin-left: 8px; }
</style>
